// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".facesheet-table{max-height:calc(100vh - 160px);position:relative;isolation:isolate}.facesheet-table thead th{position:sticky;top:0;z-index:103;background-color:var(--color-white);background-image:linear-gradient(to top, var(--color-white), #fafbfc);box-shadow:inset 0 -1px 0 var(--color-table-rule)}", ""]);
// Exports
module.exports = exports;
